export default __webpack_public_path__ + "static/media/ellipse_slide_student_four.ea8f6bbe.svg";